module.exports = __webpack_public_path__ + "static/media/bed-bunk.5ea0530b.svg";